import { render, staticRenderFns } from "./RegReportView.vue?vue&type=template&id=0b91d9dc"
import script from "./RegReportView.vue?vue&type=script&lang=js"
export * from "./RegReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports